import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import loadingJson from '../../animations/loading.json';
import { SemanticColor, semanticColorsV1 } from '../../theme/colors';
import { LottieAnimationViewV1 } from './LottieAnimationViewV1';

/** v1 design of loading animation (as in master): `loading.json` recolored with `IconEmphasised`. Rendered for widgets without `version: 2`. */
export const LoadingAnimationV1 = ({ widget }: TWidgetProps<TCommonData>) => {
    return (
        <LottieAnimationViewV1
            dataTest={widget.uid ?? 'loader'}
            animationData={loadingJson}
            animationsColor={semanticColorsV1[SemanticColor.IconEmphasised]}
            loop
            size="80px"
            margin={widget.options?.margin}
        />
    );
};
